var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidemenuFillIcon",
    width: 22,
    height: 23,
    viewBox: "0 0 650 679",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 155v476c0 26 22 48 49 48h552c27 0 49-22 49-48V155c0-26-22-48-49-48h-56v-5c0-17-5-36-17-50c-13-13-33-23-62-23c-30 0-50 10-62 23c-13 14-18 33-18 50v5H264v-5c0-17-5-36-17-50c-13-13-33-23-63-23c-29 0-49 10-61 23c-13 14-18 33-18 50v5H49c-27 0-49 22-49 48zm66 459V510h117v104H66zm0-120V390h117v104H66zm0-120V269h117v105H66zm87-188v-84c0-16 10-24 31-24c22 0 32 8 32 24v84c0 16-10 24-32 24c-21 0-31-8-31-24zm46 428V510h118v104H199zm0-120V390h118v104H199zm0-120V269h118v105H199zm134 240V510h118v104H333zm0-120V390h118v104H333zm0-120V269h118v105H333zm134 240V510h117v104H467zm0-120V390h117v104H467zm0-120V269h117v105H467zm-33-188v-84c0-16 10-24 32-24c20 0 31 8 31 24v84c0 16-10 24-31 24c-22 0-32-8-32-24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeTable);
export default __webpack_public_path__ + "static/media/IconTimeTable.6edf2f2f9b4777b32401a21b1d56d941.svg";
export { ForwardRef as ReactComponent };